import { setCookie } from './cookieHelpers'

export function initFooterCurrencySwitcher () {
  const currencySelect = document.getElementById('vjs-footer-currency-select')
  if (!currencySelect) return

  currencySelect.addEventListener('change', (e) => {
    const selectedCurrency = e.target.value
    setCookie('user_currency', selectedCurrency, 365)
    window.location.reload()
  })
}
